import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import ArrowIcon from "./images/arrow.svg";
import OrangeTick from "./images/orange-tick.svg";
import { getBoldText } from "../../../../utils/helpers/get-span-for-bold-text";

const ManufacturerLevelCoverage = ({ isBundlePitch, onModalOpen, bannerData }) => {
    const { title = "", subTitle = "", images = [], pointers = [] } = bannerData || {};

    if (!title || !subTitle) return null;

    return (
        <div styleName="styles.outer">
            <div styleName="styles.contentWrapper">
                {/* Title Section */}
                <div styleName="styles.titleSection">
                    <h2 styleName="styles.heading">{title?.replaceAll("**", "")}</h2>
                    <p styleName="styles.coverageText">
                        {getBoldText(subTitle)}
                    </p>
                </div>

                {/* Car Illustration */}
                {images?.length > 0 && (
                    <div styleName="styles.carIllustrationContainer">
                        <img src={images[0]?.imageUrl} alt="Car Illustration" />
                    </div>
                )}

                {/* Modal Button */}
                {isBundlePitch ? (
                    <div styleName="styles.list">
                        {pointers?.length > 0 && pointers.map((el, index) => (
                            <div key={index} styleName="styles.listItem">
                                <img src={OrangeTick} alt="Orange Tick" />
                                <p>{getBoldText(el.info)}</p>
                            </div>
                        ))}
                        <button styleName="styles.actionButton styles.button" onClick={onModalOpen}>
                        More about CARS24 warranty
                            <img src={ArrowIcon} alt="Arrow Icon" />
                        </button>
                    </div>
                ) : (
                    <button styleName="styles.actionButton" onClick={onModalOpen}>
                        See what's covered
                        <img src={ArrowIcon} alt="Arrow Icon" />
                    </button>
                )}
            </div>
        </div>
    );
};

ManufacturerLevelCoverage.propTypes = {
    isBundlePitch: PropTypes.bool,
    onModalOpen: PropTypes.func,
    bannerData: PropTypes.object
};

export default ManufacturerLevelCoverage;
